// First name from a Google / Facebook sign-in result: the provider's own
// first-name field (Google given_name, Facebook first_name), else the first
// word of the full display name ("James Peachey" → "James").
export const firstNameFromSignIn = (result) => {
  const profile = result?.additionalUserInfo?.profile || {};
  const given = profile.given_name || profile.first_name;
  if (given && String(given).trim()) return String(given).trim();
  return String(result?.user?.displayName || '').trim().split(/\s+/)[0] || '';
};
